import * as React from 'react';

import {
	Root,
	LinkStyled,
	Name,
} from './styled';


export type SidebarItemProps = {
	path: string;
	sysName: string;
	name: string;
	renderIcon: (sysName: string) => React.ReactNode;
}

const SidebarItem: React.SFC<SidebarItemProps> = props => {
	const {
		path,
		sysName,
		name,
		renderIcon,
		...rest
	} = props;

	return (
		<Root {...rest}>
			<LinkStyled to={path}>
				{renderIcon(sysName)}
				<Name>{name}</Name>
			</LinkStyled>
		</Root>
	);
}

SidebarItem.displayName = 'SidebarItem';
SidebarItem.defaultProps = {};

export default SidebarItem;
